// User-facing strings for the Incident Feed.
//
// 🔴 **Never render an error message that came back from the API.** Transport errors
// ("Request failed with status code 401"), stack traces and server `errors[].desc`
// strings are for the console and Redux DevTools, not for an admin looking at a
// dashboard — they are noise at best and leak internal detail at worst. The slice still
// keeps the detail on `<thing>Error` for debugging; the UI shows LOAD_ERROR instead,
// whatever actually went wrong.
export const LOAD_ERROR = 'Error in loading data'

// Distinct from LOAD_ERROR on purpose (D-7): "nothing has computed this yet" is a normal
// state for a valid customer, not a failure, and must not read as one.
export const NOT_COMPUTED_TITLE = 'Data not yet available'
export const NOT_COMPUTED_NOTE =
  'Phishing detections have not been computed for this organization yet.'
